export default {
	data() {
		return {
			optionOrder: [],
			calculatedColumns: this.columns,
			elementWidth: 0
		};
	},
	props: {
		columns: { type: Number, default: 0 },
		options: { type: Array, default: null }
	},
	mounted() {
		if (this.columns > 0) {
			this.sortIntoColumns();
			window.addEventListener('resize', this.sortIntoColumns);
			this.addResetDataCallback(this.sortIntoColumns);
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.sortIntoColumns);
	},
	computed: {
		hasColumns() {
			return this.calculatedColumns >= 1 && this.calculatedColumns <= 4;
		},
		columnClasses() {
			return `cog-inner-col cog-inner-col--${this.calculatedColumns}`;
		},
		minimumColWidth() {
			if (!this.imagesInChoiceFieldsEnabled)
				return 130;

			let fontSizeMultiplier;
			const cardAdjustment = this.isCard ? 7 : 0; // Cards have padding on either side but they don't have a checkable taking up space
			let imageAdjustment = 0;
			let hasLongLabels = false;

			if (this.showChoiceImages || !this.hideChoiceLabels)
				fontSizeMultiplier = parseInt(getComputedStyle(this.$el).fontSize) / 14;

			if (this.showChoiceImages)
				imageAdjustment = (this.choiceImageSize + 1) * 19 * (2.3 * fontSizeMultiplier);

			if (!this.hideChoiceLabels) {
				hasLongLabels = (this.options || []).some(curr => {
					const label = (this.isCard ? curr.label : curr.displayValue) || '';
					const longestCardDescription = this.isCard && curr.description ? curr.description.length * fontSizeMultiplier : 0;
					const labelWidth = label.length * fontSizeMultiplier;
					const longestLabel = Math.max(...label.split(' ').map(word => word.length)) * fontSizeMultiplier;
					return labelWidth > 150 || longestLabel >= 20 || longestCardDescription > 23;
				});
			}

			const labelAdjustment = this.hideChoiceLabels ? 0 : hasLongLabels ? 180 : 110;
			const contentAdjustment = this.isCard && this.cardLabelPosition === 'bottom' ? Math.max(labelAdjustment, imageAdjustment) : labelAdjustment + imageAdjustment;

			return cardAdjustment + contentAdjustment;
		}
	},
	watch: {
		options() {
			if (this.columns > 0)
				this.sortIntoColumns();
		}
	},
	methods: {
		sortIntoColumns() {
			this.calculatedColumns = Math.max(1, Math.min(Math.floor(this.$el.clientWidth / this.minimumColWidth), this.columns));
			const numberOfColumns = this.calculatedColumns;

			let optionsAmt;
			if (this.readonly)
				optionsAmt = this.selectedOptions?.length ?? (this.selectedValue ? 1 : 0); // selectedOptions for checkboxes, selectedValue for Radio buttons
			else
				optionsAmt = this.options?.length;

			const numberOfItems = this.allowOther && !this.readonly ? optionsAmt + 1 : optionsAmt;
			const itemsPerColumn = numberOfItems / numberOfColumns;

			let itemsPerColumnRounded = Math.ceil(itemsPerColumn);
			const partialColumns = numberOfColumns - (numberOfItems % numberOfColumns);
			let hasPartialColumns = partialColumns !== numberOfColumns;
			const columns = [];
			let col = 0; let row = -1;
			for (let i = 0; i < numberOfItems; i++) {
				row++;
				if (row >= itemsPerColumnRounded) {
					row = 0;
					col++;
				}
				columns[row * numberOfColumns + col] = i;
				if (hasPartialColumns && i + 1 === numberOfItems - (partialColumns * (itemsPerColumnRounded - 1))) {
					itemsPerColumnRounded--;
					hasPartialColumns = false;
				}
			}

			const options = [];
			for (let j = 0; j < numberOfItems; j++) {
				options[columns[j]] = j;
			}

			this.optionOrder = options;
		}
	}
};